import { block, variants, fill } from "./Logo.css.mjs";
const DEFAULT_LOGO_SIZE = 40;
function resolveSvgProps({
  size,
  variant,
  brandClass
}) {
  return {
    height: size === "fill" ? "100%" : DEFAULT_LOGO_SIZE,
    className: `${block} ${variants[variant]} ${brandClass}${size === "fill" ? ` ${fill}` : ""}`
  };
}
export {
  resolveSvgProps
};
